import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  accordion: {
    margin: '0px !important',
    borderTop: '2px solid #ECECEC',
  },
  container: {
    display: 'block',
    width: '80%',
    margin: 'auto',
  },

  expandIcon: {
    color: '#DF0C36',
  },
  heading: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: '28px',
    color: '#666666',
  },
  secondaryHeading: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    lineHeight: '18px',
    color: '#CCCCCC',
    marginTop: 6,
    marginRight: 46,
    right: 0,
    position: 'absolute',
  },
  totalDiv: {
    display: 'flex',
    border: '1px solid #CCCCCC',
    height: 52,
    alignItems: 'center',
  },
  totalAmount: {
    float: 'right',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    lineHeight: '20px',
    color: '#000000',
    margin: '0 12px',
    whiteSpace: 'nowrap',
  },
  totalLabel: {
    width: 200,
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 16,
    lineHeight: '24px',
    color: '#000000',
    margin: '0 12px',
  },
}));
